<div [ngClass]="{'bg-green-700/20' : formControl.value, 'bg-neutral-50' : !formControl.value}"
  class="self-stretch w-full rounded-xl border border-neutral-300 justify-start items-center gap-3 flex flex-col">
  <div [ngClass]="(option.value?.description?.[locale]) ? 'border-b border-zinc-200' : ''"
    class="flex flex-row justify-between w-full text-blue-900 text-xs md:text-sm font-medium leading-normal inline-flex gap-1 items-center">
    <div class="flex flex-row w-3/4 p-4">
      <!-- Checkbox / Toggle switch-->
      <label class="inline-flex items-center cursor-pointer mr-3">
        <input type="checkbox" [formControl]="formControl" class="sr-only peer">
        <div
          class="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-green-600">
        </div>
      </label>

      <!-- Name -->
      <div class="">
        <div class="text-black flex gap-1 items-center">
          <p class="font-bold text-lg text-blue-900">{{option.value.name[locale]}}</p>
        </div>
      </div>
    </div>

    <!-- Price and info icon -->
    <div class="flex flex-row gap-2 w-1/4 justify-end p-4">
      <div>
        @if(option.value.discountCheckAmount > 0 || option.value.discountCheckPercent > 0) {
          <p class="text-xs md:text-xl font-bold">{{option.value.discountTotalPrice.toLocaleString(locale) }}
            SEK
          </p>
          <p class="text-[10px] md:text-base line-through decoration-red-600">{{
            option.value.totalPrice.toLocaleString(locale)}} SEK
          </p>
          }@else {
          <span class="font-bold text-lg text-black">{{option.value.totalPrice.toLocaleString(locale)}} SEK
          </span>
        }
      </div>
    </div>
  </div>
  @if(option.value?.description?.[locale]) {
    <div
      class="flex flex-col w-full text-blue-900 text-xs md:text-lg font-medium leading-normal inline-flex gap-1 pb-3">
      @if ((option.value.name['sv'] == 'Lagning av stenskott') || (option.value.name['sv'] == 'Byt eller laga vindruta')) {
        <div
          class="mb-2 ml-[57px]">
          <img src="../../../../assets/img/Carglass-logo.svg" alt="Info icon" class="width-100px" />
        </div>
      }
      @if ((option.value.name['sv'] == 'Bilbesiktning')) {
        <div class="mb-2 ml-[57px]">
          <img src="../../../../assets/img/Carspect_logo.svg" alt="Info icon" class="width-100px" />
        </div>
      }
      @if ((option.value.name['sv'] == 'Bilservice')) {
        <div class="mb-2 ml-[57px]">
          <img src="../../../../assets/img/car_service_logo.png" alt="Info icon" class="width-100px" />
        </div>
      }
      <div class="text-black flex ml-[57px]">
        <p class="Text text-base self-stretch text-sm font-normal leading-normal padding-right-15">
          {{ option.value.description[locale] }}
        </p>
      </div>
    </div>
  }

</div>